(function () {
  angular.module("akitabox.ui.components.floorCard", [
    "akitabox.core.services.floor",
    "akitabox.core.services.flag",
    "akitabox.core.services.tagCategory",
    "akitabox.core.toast",
    "akitabox.ui.dialogs.document.select",
  ]);
})();
